import type { AllRouteEndpoints } from "../routeTypes";

export const getCampaignsDataCacheKey = "/engagement/campaigns_data" as const;
export const postCampaignCacheKeys: AllRouteEndpoints[] = [
  "/engagement/campaigns",
  "/engagement/:app_group_id/feature_flags/:rollout_id/experiment_usage",
  "/engagement/feature_flag_rollouts_data",
  "/engagement/:app_group_id/feature_flags/:rollout_id/dependencies",
  "/engagement/:app_id/feature_flags_eligibility/:user_id/:device_id",
];

export const postCampaignCopyCacheKeys: AllRouteEndpoints[] = [];

export const CAMPAIGN_WIDE = "campaign-wide";
